const WidgetType = Object.freeze({
  SOCIAL_WEB_AUTHORS: 'SOCIAL_WEB_AUTHORS',
  AUDIENCE_AUTHORS: 'AUDIENCE_AUTHORS',
  SOCIAL_WEB_DOMAINS: 'SOCIAL_WEB_DOMAINS',
  SOCIAL_WEB_GEO_REGIONS: 'SOCIAL_WEB_GEO_REGIONS',
  AUDIENCE_GEO_REGIONS: 'AUDIENCE_GEO_REGIONS',
  HEADER: 'HEADER',
  IMAGE: 'IMAGE',
  SOCIAL_WEB_SUMMARY_METRICS_COMPACT: 'SOCIAL_WEB_SUMMARY_METRICS_COMPACT',
  AUDIENCE_SUMMARY_METRICS_COMPACT: 'AUDIENCE_SUMMARY_METRICS_COMPACT',
  SOCIAL_WEB_SENTIMENT: 'SOCIAL_WEB_SENTIMENT',
  AUDIENCE_SENTIMENT: 'AUDIENCE_SENTIMENT',
  SOCIAL_WEB_STREAM: 'SOCIAL_WEB_STREAM',
  AUDIENCE_STREAM: 'AUDIENCE_STREAM',
  YOUTUBE_STREAM: 'YOUTUBE_STREAM',
  SOCIAL_WEB_POPULAR_POSTS: 'SOCIAL_WEB_POPULAR_POSTS',
  SOCIAL_WEB_POPULAR_LINKS: 'SOCIAL_WEB_POPULAR_LINKS',
  AUDIENCE_POPULAR_LINKS: 'AUDIENCE_POPULAR_LINKS',
  TEXT: 'TEXT',
  SOCIAL_WEB_TIMELINE: 'SOCIAL_WEB_TIMELINE',
  SOCIAL_WEB_TIMELINE_OLD: 'SOCIAL_WEB_TIMELINE_OLD',
  SOCIAL_WEB_TIMELINE_COMPARISON: 'SOCIAL_WEB_TIMELINE_COMPARISON',
  AUDIENCE_TIMELINE: 'AUDIENCE_TIMELINE',
  AUDIENCE_TIMELINE_OLD: 'AUDIENCE_TIMELINE_OLD',
  AUDIENCE_TIMELINE_COMPARISON: 'AUDIENCE_TIMELINE_COMPARISON',
  YOUTUBE_TIMELINE: 'YOUTUBE_TIMELINE',
  SOCIAL_WEB_TOPIC_COMPARISON: 'SOCIAL_WEB_TOPIC_COMPARISON',
  AUDIENCE_TOPIC_COMPARISON: 'AUDIENCE_TOPIC_COMPARISON',
  SOCIAL_WEB_WORDCLOUD: 'SOCIAL_WEB_WORDCLOUD',
  SOCIAL_WEB_SENTIMENT_DRIVERS: 'SOCIAL_WEB_SENTIMENT_DRIVERS',
  SOCIAL_WEB_PHOTO_CONCEPTS: 'SOCIAL_WEB_PHOTO_CONCEPTS',
  AUDIENCE_WORDCLOUD: 'AUDIENCE_WORDCLOUD',
  AUDIENCE_SENTIMENT_DRIVERS: 'AUDIENCE_SENTIMENT_DRIVERS',
  SOCIAL_WEB_CROSSTAB: 'SOCIAL_WEB_CROSSTAB',
  AUDIENCE_CROSSTAB: 'AUDIENCE_CROSSTAB',
  SOCIAL_WEB_BRAND_PASSION_INDEX: 'SOCIAL_WEB_BRAND_PASSION_INDEX',
  AUDIENCE_USAGE_AND_ATTITUDE: 'AUDIENCE_USAGE_AND_ATTITUDE',
  SOCIAL_WEB_SOURCES: 'SOCIAL_WEB_SOURCES',
  SOCIAL_WEB_INDEX: 'SOCIAL_WEB_INDEX',
  SOCIAL_WEB_DEMOGRAPHIC: 'SOCIAL_WEB_DEMOGRAPHIC',
  AUDIENCE_INDEX: 'AUDIENCE_INDEX',
  AUDIENCE_DEMOGRAPHIC: 'AUDIENCE_DEMOGRAPHIC',
  HTML: 'HTML',
  SOCIAL_WEB_STORY_SCOPE: 'SOCIAL_WEB_STORY_SCOPE',
  SOCIAL_WEB_TRENDING: 'SOCIAL_WEB_TRENDING',
  AUDIENCE_TRENDING: 'AUDIENCE_TRENDING',
  AUDIENCE_INSIGHTS: 'AUDIENCE_INSIGHTS',
  WHITESPACE: 'WHITESPACE',
  SOCIAL_WEB_POPULAR_MEDIA: 'SOCIAL_WEB_POPULAR_MEDIA',
  AUDIENCE_POPULAR_MEDIA: 'AUDIENCE_POPULAR_MEDIA',
  SOCIAL_WEB_SUMMARY_METRICS: 'SOCIAL_WEB_SUMMARY_METRICS',
  AUDIENCE_SUMMARY_METRICS: 'AUDIENCE_SUMMARY_METRICS',
  YOUTUBE_SUMMARY_METRICS: 'YOUTUBE_SUMMARY_METRICS',
  SOCIAL_WEB_DAY_AND_HOUR: 'SOCIAL_WEB_DAY_AND_HOUR',
  AUDIENCE_DAY_AND_HOUR: 'AUDIENCE_DAY_AND_HOUR',
  GEO_TAGGED: 'GEO_TAGGED',
  SOCIAL_WEB_LANGUAGE: 'SOCIAL_WEB_LANGUAGE',
  AUDIENCE_LANGUAGE: 'AUDIENCE_LANGUAGE',
  RICH_TEXT: 'RICH_TEXT',
  SOCIAL_WEB_TAGS: 'SOCIAL_WEB_TAGS',
  SOCIAL_WEB_CHANNELS: 'SOCIAL_WEB_CHANNELS',
  NP_STREAM: 'NP_STREAM',
  NP_POSTS: 'NP_POSTS',
  NP_SENTIMENT: 'NP_SENTIMENT',
  NP_DEMOGRAPHICS: 'NP_DEMOGRAPHICS',
  NP_POPULAR_ITEMS: 'NP_POPULAR_ITEMS',
  NP_TOP_DOMAINS: 'NP_TOP_DOMAINS',
  NP_AUTHORS: 'NP_AUTHORS',
  NP_TOP_POSTS: 'NP_TOP_POSTS',
  NP_TOP_MEDIA: 'NP_TOP_MEDIA',
  NP_ENGAGEMENTS: 'NP_ENGAGEMENTS',
  NP_IMPRESSIONS: 'NP_IMPRESSIONS',
  NP_SOURCES: 'NP_SOURCES',
  NP_SENTIMENT_DRIVERS: 'NP_SENTIMENT_DRIVERS',
  NP_GEOGRAPHY: 'NP_GEOGRAPHY',
  NP_DAY_HOUR: 'NP_DAY_HOUR',
  SOCIAL_WEB_SIDE_BY_SIDE: 'SOCIAL_WEB_SIDE_BY_SIDE',
  NP_MEDIA: 'NP_MEDIA',
  CUSTOM_VISUALIZATION: 'CUSTOM_VISUALIZATION'
})
export default WidgetType
// RESERVE BELOW

export type WidgetTypeStrings = typeof WidgetType[keyof typeof WidgetType]
